import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';

import { IBeneficiaryCredimorarFormDialogData } from 'src/app/models/dialog';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

import {
    ContratoBeneficiarioFormComponent
} from '../contrato-beneficiario-form/contrato-beneficiario-form.component';

@Component({
  selector: 'app-contrato-editar-valor-credimorar',
  templateUrl: './contrato-editar-valor-credimorar.component.html',
  styleUrls: ['./contrato-editar-valor-credimorar.component.scss']
})
export class ContratoEditarValorCredimorarComponent implements OnInit {

  valorCredimorarEditForm: FormGroup;
  submitted: boolean = false;

  constructor(
    private _dialogRef: MatDialogRef<ContratoBeneficiarioFormComponent>,
    private fb: FormBuilder,
    private _snackbarService: SnackbarService,
    private _apiContractService: ApiContractService,
    @Inject(MAT_DIALOG_DATA)
    public parentData: IBeneficiaryCredimorarFormDialogData
  ) {

    this.valorCredimorarEditForm = this.fb.group({
      valor: ['', [Validators.required]],
    });

  }

  ngOnInit(): void {

    this.valorCredimorarEditForm.patchValue({
      valor: this.parentData.amount,
    });


  }

  onSubmit(): void {

    this.submitted = true;
    if (this.valorCredimorarEditForm.invalid) {

      const formControls = this.valorCredimorarEditForm.controls;
      for (const controlName in formControls) {
        if (formControls.hasOwnProperty(controlName)) {
          const control = formControls[controlName];
          if (control.errors) {
            control.markAsTouched();
          }
        }
      }

      this._snackbarService.openSnackBar(
        'O formulário deve ser preenchido corretamente!',
        'warning'
      );

      return;
    }

    const valor = this.valorCredimorarEditForm.value.valor;
    const updateValue = {
      contractId: this.parentData.contractId,
      beneficiaryId: this.parentData.beneficiaryId,
      amount: valor
    };

    this._apiContractService.updateCredimorarContractValue(this.parentData.contractId, updateValue)
      .subscribe({
        next: (result) => {

          this._snackbarService.openSnackBar(
            'O valor do contrato foi alterado com sucesso!',
            'success'
          );

          location.reload();

        },
        error(err) {
          console.error(err);
        },
      });
  }

  hasError(controlName: string, errorName: string): boolean {
    const control = this.valorCredimorarEditForm.get(controlName);
    return (
      !!control &&
      ((control.touched && this.submitted) || this.submitted) &&
      control.errors &&
      control.errors[errorName]
    );
  }

  closeDialogCommissionEdit(result?: any): void {
    this._dialogRef.close(result);
  }

}
